export const API_BASE_URL = 'https://gangapurschool.pythonanywhere.com';